export class BrandManagerRequest {
  name: string = "";
  birthday: string = "";
  gender: number = 1;
  avatar: string = "";
  phone: string = "";
  address: string = "";
  username: string = "";
  joining_date: string = "";
  id_card_number: string = "";
  identifier_name: string = "";
  company_id: string = "";
  brand_name: string = "";

  constructor(data?: Partial<BrandManagerRequest>) {
    Object.assign(this, data);
  }
}
